import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appAlphabets]'
})
export class AlphabetsDirective {

    private navigationKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Escape',
        'Enter',
        'Home',
        'End',
        'ArrowLeft',
        'ArrowRight',
        'Clear',
        'Copy',
        'Paste'
    ];
    inputElement: HTMLElement;
    constructor(public el: ElementRef) {
        this.inputElement = el.nativeElement;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        if (
            this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        // console.log(e.keyCode);
        if (
            (e.keyCode < 65 || e.keyCode > 90) &&
            (e.keyCode < 97 || e.keyCode > 122) &&
            (e.keyCode != 32) 
        ) {
            e.preventDefault();
        }
        if(e.keyCode >= 97 && e.keyCode <= 111) {
            e.preventDefault();
        }
        if(e.keyCode == 111 || e.keyCode == 106 || e.keyCode == 107 || e.keyCode == 109) {
            e.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedInput: string = event.clipboardData?.getData('text/plain')
            .replace(/[a-zA-Z0-9]/g, '') || ""; // get a digit-only string
        document.execCommand('insertText', false, pastedInput);
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        const textData = event.dataTransfer?.getData('text').replace(/[a-zA-Z0-9]/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }


}